import React from 'react'
import AttrLike from './AttrLike'
import AttrSave from './AttrSave'
/* REDUX */
import { connect } from 'react-redux'

class Tag extends React.Component {
	render() {
		const { tag } = this.props
		return (
			<li>
				<span>{ tag }</span>
			</li>
		)
	}
}

class EndBar extends React.Component {
	render() {
		const { report_id, tags, likesCount, commentsCount } = this.props
		if (!tags) {
			return <div></div>
		}
		const tagsList = tags.map((tag, index) => {
			return <Tag key={ index } tag={ tag } />
		})
		return (
			<div className="endbar">
				<div className="tags">
					<ul>
						{ tagsList }
					</ul>
				</div>
				<div className="d-flex align-items-center">
					<AttrLike onLogin={ this.props.onLogin } report_id={ report_id } commentsCount={ commentsCount } />
					<AttrSave onLogin={ this.props.onLogin } report_id={ report_id } />
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const report_id = ownProps.params.report_id
	const { reportById } = state
	const { report } = reportById[report_id]
	const { tags, commentsCount, likes } = report || {}
	const likesCount = likes ? likes.length : 0
	return {
		report_id,
		tags,
		likesCount,
		commentsCount
	}
}

export default connect(mapStateToProps)(EndBar)


// WEBPACK FOOTER //
// ./src/components/Report/EndBar.js